import { axios, serializeParams } from '@/lib/helpers';
import { createAction } from '@reduxjs/toolkit';
import { api } from '@/lib/trpc/client';
export const salesOrdersRequestStarted = createAction('sales-orders/request/started');
export const salesOrdersRequestFailed = createAction('sales-orders/request/failed');

export const salesOrdersFetchSucceeded = createAction('sales-orders/fetch/succeeded');

function getTrcpErrorMessage(error) {
  return error?.message || error?.data?.code;
}

export const fetchSalesOrders = (shopId) => (dispatch, getState) => {
  dispatch(salesOrdersRequestStarted());

  const state = getState();

  const userState = state.user;
  const { user, activeChain } = userState;

  const salesOrdersSearchState = state.salesOrdersSearch;
  const { activeFilters, activeTab } = salesOrdersSearchState;
  const activeFiltersActiveTabIncluded = {
    ...activeFilters,
    ...getRequestParamsForActiveTab(activeTab),
  };

  const requestParams = Object.keys(activeFiltersActiveTabIncluded).reduce((acc, key) => {
    if (activeFiltersActiveTabIncluded[key]) {
      acc[key] = {
        operator: 'equals',
        // value: encodeURIComponent(activeFiltersActiveTabIncluded[key]),
        value: activeFiltersActiveTabIncluded[key],
      };
    }
    return acc;
  }, {});

  const mapToFilters = {
    chain: {
      key: 'chains',
      type: 'stringArray',
    },
    id: {
      key: 'salesOrderGroupIds',
      type: 'numberArray',
    },
    archived: {
      key: 'archived',
      type: 'boolean',
    },
    accepted: {
      key: 'accepted',
      type: 'boolean',
    },
    season: {
      key: 'seasons',
      type: 'stringArray',
    },
    quarter: {
      key: 'quarters',
      type: 'stringArray',
    },
    generalItemCategoryGroup: {
      key: 'generalItemCategoryGroups',
      type: 'stringArray',
    },
    brand: {
      key: 'brands',
      type: 'stringArray',
    },
    type: {
      key: 'types',
      type: 'stringArray',
    },
    status: {
      key: 'status',
      type: 'stringArray',
    },
    orderType: {
      key: 'orderType',
      type: 'array',
    },
  };

  const getValue = (param) => {
    if (param?.operator === 'equals') {
      return param.value;
    }
    return param;
  };

  const filters = Object.keys(requestParams).reduce((acc, key) => {
    const param = requestParams[key];
    const queryKey = mapToFilters[key]?.key;
    const queryType = mapToFilters[key]?.type;
    if (!queryKey) {
      return acc;
    }

    switch (queryType) {
      case 'array':
        acc[queryKey] = Array.isArray(param) ? param : getValue(param);
        break;
      case 'stringArray':
        acc[queryKey] = (Array.isArray(param) ? param : [param]).map((p) => String(getValue(p)));
        break;
      case 'numberArray':
        acc[queryKey] = (Array.isArray(param) ? param : [param]).map((p) => +getValue(p));
        break;
      case 'boolean':
        acc[queryKey] = ['1', '0', true, false].includes(param?.value) ? !!+param?.value : false;
        break;
      case 'number':
        acc[queryKey] = +getValue(param);
        break;
      case 'string':
        acc[queryKey] = getValue(param);
        break;
    }
    return acc;
  }, {});

  return api.salesOrders.getSalesOrders
    .query({
      shopId: shopId,
      chain: activeChain,
      filters: {
        ...filters,
        excludeNosOrders: true, // Always exclude NOS orders from this list
      },
    })
    .then(
      ({ result }) => dispatch(salesOrdersFetchSucceeded(result)),
      (error) => dispatch(salesOrdersRequestFailed(getTrcpErrorMessage(error)))
    );
};

function getRequestParamsForActiveTab(activeTab) {
  switch (activeTab) {
    default:
    case 'SALES_ORDERS_ACTIVE':
      return {
        archived: '0',
        accepted: '0',
        orderType: ['SALES_ORDER_DIRECT', 'SALES_ORDER_WAREHOUSE'],
      };
    case 'SALES_ORDERS_ACCEPTED':
      return {
        archived: '0',
        accepted: '1',
        orderType: ['SALES_ORDER_DIRECT', 'SALES_ORDER_WAREHOUSE'],
      };
    case 'SALES_ORDERS_ARCHIVED':
      return {
        archived: '1',
        orderType: ['SALES_ORDER_DIRECT', 'SALES_ORDER_WAREHOUSE'],
      };
  }
}

export const setActiveShop = createAction('sales-orders/active-shop/set');

export const salesOrdersReportFetchSucceeded = createAction(
  'sales-orders/revision-report/succeeded'
);

export const salesOrdersHideReportDialog = createAction('sales-orders/revision-report/hide-dialog');

export const fetchSalesOrdersRevisionReport = (requestParams) => (dispatch, getState) => {
  dispatch(salesOrdersRequestStarted());

  const state = getState();
  const userState = state.user;
  const { activeChain } = userState;

  return api.salesOrders.getSalesOrdersRevisionReport
    .query({
      season: requestParams.season,
      quarter: requestParams.quarter,
      brand: requestParams.brand,
      chain: activeChain,
      types: requestParams.types,
    })
    .then(
      ({ result }) => dispatch(salesOrdersReportFetchSucceeded(result)),
      (error) => dispatch(salesOrdersRequestFailed(getTrcpErrorMessage(error)))
    );
};

export const fetchSalesOrdersEdiList = (requestParams) => (dispatch, getState) => {
  dispatch(salesOrdersRequestStarted());

  const state = getState();
  const userState = state.user;
  const { activeChain } = userState;

  return api.salesOrders.getSalesOrdersEdiList
    .query({
      season: requestParams.season,
      quarter: requestParams.quarter,
      brand: requestParams.brand,
      chain: activeChain,
    })
    .then(
      ({ result }) => dispatch(salesOrdersReportFetchSucceeded(result)),
      (error) => dispatch(salesOrdersRequestFailed(getTrcpErrorMessage(error)))
    );
};
